import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import * as _ from 'lodash-es';
import { DipStateService } from '../services/dip-state-service.service';

@Component({
    selector: 'together-auction-dip-info',
    templateUrl: './dip.dip_info.component.html',
    standalone: false
})
export class TogetherAuctionDIPInfoComponent implements OnInit {
    @Input() stage;
    @Input() incoming_case_id: string;

    _forwardText: string = 'Check your eligibility';
    _showAction: boolean = false;
    _showForward: boolean = true;
    _showBackward: boolean = false;
    @Output() stage_changing = new EventEmitter();

    onForwardClicked() {
        this.stage_changing.emit(this.stage.forward_stage.reference);
    }

    ngOnInit() {
        window.scrollTo(0, 0);
    }

    constructor(private state: DipStateService) {
        // If we're here it's definitely NEW a DIP case, therefor a resi property
        this.state.isDipJourney.next(true);
        this.state.propertyType.next(0);
        this.state.caseId.next('00000000-0000-0000-0000-000000000000');
    }

}
